// extracted by mini-css-extract-plugin
export default {"filtering-and-sorting":"filtering-and-sorting--EF2XQ","filteringAndSorting":"filtering-and-sorting--EF2XQ"};